// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppBreadcrumb_prevLink__NJ7cg {
  color: #873caa;
  font-size: 16px;
  line-height: 21.79px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/styles/AppBreadcrumb.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":[".prevLink {\n  color: #873caa;\n  font-size: 16px;\n  line-height: 21.79px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prevLink": `AppBreadcrumb_prevLink__NJ7cg`
};
export default ___CSS_LOADER_EXPORT___;
